import http from '@/shared/api/http'

export async function getAllProductTypes() {
  return (await http.get('product-types')).data
}

export async function getProductTypeById(productTypeId) {
  return (await http.get(`product-types/${productTypeId}`)).data
}

export async function createProductType(payload) {
  return (await http.post('product-types', payload)).data
}

export async function updateProductType(payload) {
  return (
    await http.put(`product-types/${payload.Id}`, payload, {
      headers: { 'Content-Type': 'application/json' }
    })
  ).data
}

export async function deleteProductType(productTypeId) {
  return (await http.delete(`product-types/${productTypeId}`)).data
}